import React from 'react';

import { Block, withConfig } from '../common/Block.jsx';
import { EmptyContentPlaceholder } from '../layout/Builder.jsx';
import { ContentContainer as PostContentContainer } from './PostContent.jsx';
import { ContentContainer, withPaging } from '../common/List.jsx';
import { View as LoadingView } from '../common/Loading.jsx';

class _MediaList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.onRegisterRequestDataHandler((requestData) => {
            const props = this.props;
            const blockConfig = props.onNormalizeBlockConfig(props);
            requestData.tags = blockConfig.tags;

            if (props.context) {
                requestData.artistId = props.context.artistId;
                requestData.inventoryId = props.context.inventoryId;
                requestData.listId = props.context.listId;
            }
            if (props.builder) {
                requestData.limit = 3;
            }
        });
        if (!this.props.data) {
            this.props.onLoad();
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.builder || !this.props.blockConfig || !prevProps.context) {
            return;
        }
        const blockConfig = this.props.onNormalizeBlockConfig(this.props);
        if (prevProps.context.tags != blockConfig.tags) {
            this.props.onReset(this.props.onLoad);
        }
    }

    render() {
        const props = this.props;
        let lineSpacing;
        if (props.blockConfig && props.blockConfig.block && props.blockConfig.block.lineSpacing && props.blockConfig.block.lineSpacing.unit != undefined) {
            const value = props.blockConfig.block.lineSpacing.value || 0;
            lineSpacing = `${value}${props.blockConfig.block.lineSpacing.unit}`;
        }
        const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props, { alignment: 'textAlign' });
        if (!props.data || (props.data && props.data.media && props.data.media.length == 0)) {
            if (props.builder) {
                return (
                    <ContentContainer type="media">
                        <EmptyContentPlaceholder {...layoutStyles}>You haven't added any media yet. Once you do, you'll see them here.</EmptyContentPlaceholder>
                    </ContentContainer>
                );
            }
            return null;
        }
        let className = props.legacy == true ? 'editor__content' : '';
        if (props.inLayout) {
            if (!layoutStyles.containerStyle) {
                layoutStyles.containerStyle = {};
            }
            layoutStyles.containerStyle.width = '100%'
        } else {
            className += ' cont--kit__wrapper';
        }
        return (
            <div className={className} style={layoutStyles.containerStyle}>
                <ContentContainer className="cont--kit__content" style={layoutStyles.style} type="media">
                    {
                        !props.data &&
                        <LoadingView />
                    }
                    {
                        props.data &&
                        props.data.media &&
                        <React.Fragment>
                            {
                                props.data.media.map((d, i) => {
                                    return (
                                        <Cell
                                            key={i}
                                            index={i}
                                            lineSpacing={lineSpacing}
                                            {...props}
                                            data={d} />
                                    )
                                })
                            }
                        </React.Fragment>
                    }
                </ContentContainer>
            </div>
        );
    }
}
const MediaList = withConfig(withPaging(_MediaList, { path: 'media', resultKey: 'media' }));

function Cell(props) {
    if (!props.data.html && !props.data.config) {
        return null;
    }
    let style;
    if (props.data && props.data.media && props.index != props.data.media.length - 1 && props.lineSpacing) {
        style = { marginBottom: props.lineSpacing };
    }
    if (props.data.config) {
        return <PostContentContainer {...props} contentConfig={props.data.config} style={style} pageType="mediaContent" />
    }
    if (props.builder) {
        if (!style) {
            style = {};
        }
        style.pointerEvents = 'none';
    }
    let className;
    if (!props.context || (!props.context.inventoryId && !props.context.artistId && !props.context.listId)) {
        className = 'p-t-md p-b-md';
    }
    return (
        <div className={className} dangerouslySetInnerHTML={{ __html: props.data.html }} style={style} />
    );
}

export default { Component: MediaList };